import { api } from '@/shared/services/api/api';
import type { IBasePaginatedModel } from '@/shared/models/base.paginated.model';
import type { ICompanyModel } from '@/shared/models/companies/company.model';
import type { IPaginatedQueryParams } from '@/shared/models/paginated-query-params';

const companyUrl = 'admin/companies';
const userUrl = 'admin/users';

interface IAssignCompany {
  userId: string;
  companyIds: string[];
}

interface IAssignedCompanies extends IPaginatedQueryParams {
  userId: string;
  companiesAssigned: number;
}

export const companyAdminsApi = api.injectEndpoints({
  endpoints: (build) => ({
    assignCompanyToUser: build.mutation<any, IAssignCompany>({
      query: ({ userId, companyIds }) => ({
        url: `${userUrl}/${userId}/assign-company`,
        method: 'POST',
        body: { companyIds: companyIds },
      }),
    }),
    getCompanies: build.query<IBasePaginatedModel<ICompanyModel>, Partial<IAssignedCompanies>>({
      query: ({ userId, companiesAssigned }) => ({
        url: `${companyUrl}`,
        params: { page: 0, pageSize: 100, search: '', userId, companiesAssigned },
      }),
      // providesTags: (result) => providesList(result?.items ?? [], 'Companies', TypeIdsDefinitions.partialListTypeId),
    }),
  }),
});

export const { useAssignCompanyToUserMutation, useGetCompaniesQuery, useLazyGetCompaniesQuery } = companyAdminsApi;
